// extracted by mini-css-extract-plugin
export default {"wrapper":"PinCode_wrapper__irAr2","info":"PinCode_info__yhWpZ"};